import { setupDatePickersBookingBar } from './datePicker.js'
import { isMobileDown, getSize } from '../../utilities/MediaQueries.js'
import { setupQuantityTicker } from './quantityTick.js'
import { stopBodyScroll, allowBodyScroll } from '../controls/controlBodyScroll'
import { Logger } from '../../utilities/Logger'

export class BookingBar {
  constructor (elem) {
    /* ELEMENTS */
    this.logger = new Logger('Booking Bar')
    this.elem = elem
    const defaultData = this.elem.dataset
    this.showPax = defaultData.showPax !== undefined ? defaultData.showPax === 'true' : false

    this.placeHolder = this.elem.parentElement.previousElementSibling
    this.hasPlaceHolder = this.placeHolder !== null && this.placeHolder !== undefined
    this.directionElem = this.elem.querySelector('[data-bar-direction]')
    this.labelDirectionTo = this.elem.querySelector('[data-bar-direction-to]')
    this.labelDirectionFrom = this.elem.querySelector('[data-bar-direction-from]')
    this.labelDateTerm = this.elem.querySelector('[data-bar-date-term]')
    this.labelDate = this.elem.querySelector('[data-bar-date]')
    this.labelReturnDate = this.elem.querySelector('[data-bar-return-date]')
    this.buttonDirection = this.elem.querySelector('[data-bar-direction-swap]')

    this.buttonDateReset = this.elem.querySelector('[data-date-reset]')
    this.inputDates = this.elem.querySelector('[data-bar-dates]')
    this.buttonDate = this.elem.querySelector('[data-bar-date-button]')
    this.buttonReturnDate = this.elem.querySelector('[data-bar-return-date-button]')
    this.modalDate = this.elem.querySelector('[data-bar-date-modal]')
    this.modalDateClose = this.elem.querySelector('[data-bar-date-modal-close]')

    this.isReturn = false
    this.initialLoad = true

    // this.buttonDateNext = this.elem.querySelector('[data-date-next]')
    this.buttonSearch = this.elem.querySelector('[data-bar-search-button]')
    this.datePicker = {}

    /* DATA */
    this.bodyLockAttribute = 'booking-bar'
    this.formData = {}
    this.labelStrings = {}
    this.exportEvent = defaultData.exportEvent !== undefined ? defaultData.exportEvent : ''
    this.showMax = defaultData.showMax !== undefined ? defaultData.showMax === 'true' : false
    this.formData.oneWay = defaultData.oneway !== undefined ? defaultData.oneWay === 'true' : false
    this.formData.embark = defaultData.embark !== undefined ? defaultData.embark : 'Folkestone'
    this.formData.disembark = defaultData.disembark !== undefined ? defaultData.disembark : 'Calais'
    this.formData.outboundDate = defaultData.outbounddate !== undefined ? new Date(defaultData.outboundDate) : new Date()
    this.formData.returnDate = defaultData.returnDate !== undefined ? new Date(defaultData.returnDate) : ''
    this.labelStrings.itineraryLabel = defaultData.itineraryLabel !== undefined ? defaultData.itineraryLabel : 'Add return'
    this.labelDate.textContent = this.formatDate(this.formData.outboundDate)
    this.activeState = ''

    /* STATE */
    this.modalOpen = false
    this.lang = defaultData.lang ?? 'en-GB'
    this.activeState = 'date'

    /* CLASSES */
    this.barMaxClass = 'b-bar--max'
    this.phMaxClass = 'b-bar__ph--max'

    /* Optional passengers section */
    if (this.showPax) {
      /* ELEMENTS */
      this.labelPeople = this.elem.querySelector('[data-bar-passengers]')
      this.labelPeopleTerm = this.elem.querySelector('[data-bar-passengers-term]')
      this.buttonPeople = this.elem.querySelector('[data-bar-people-button]')
      this.buttonPeopleNext = this.elem.querySelector('[data-pax-next]')
      this.buttonPeopleReset = this.elem.querySelector('[data-pax-reset]')
      this.modalPeople = this.elem.querySelector('[data-bar-people-modal]')
      this.modalPeopleClose = this.elem.querySelector('[data-bar-people-modal-close]')
      this.relativePaxWrapper = this.elem.querySelector('[data-relative-pax-wrapper]')
      this.checkRelativePax = this.elem.querySelector('[data-relative-pax-control]')
      this.inputOutboundQty = this.elem.querySelector('[data-bar-outbound-qty]')
      this.inputReturnQty = this.elem.querySelector('[data-bar-return-qty]')
      this.outboundPaxControl = this.elem.querySelector('[data-outbound-pax]')
      this.returnPaxControl = this.elem.querySelector('[data-return-pax]')
      this.outboundPaxLabel = this.outboundPaxControl.querySelector('[data-label]')
      this.allQtyBtns = this.elem.querySelectorAll('.qty-tick__btn')

      /* DATA */
      this.formData.outboundPax = defaultData.outboundPax !== undefined && defaultData.outboundPax > 0 ? defaultData.outboundPax : 1
      this.formData.returnPax = defaultData.returnPax !== undefined && defaultData.outboundPax > 0 ? defaultData.returnPax : 1
      this.labelStrings.outboundPaxLabel = defaultData.outboundPaxLabel !== undefined ? defaultData.outboundPaxLabel : 'Passengers'
      this.labelStrings.outboundPaxLabelDiff = defaultData.outboundPaxLabelDiff !== undefined ? defaultData.outboundPaxLabelDiff : 'Outbound Passengers'
      this.labelStrings.outboundPaxLabelShort = defaultData.outboundPaxLabelShort !== undefined ? defaultData.outboundPaxLabelShort : 'out'
      this.labelStrings.returnPaxLabelShort = defaultData.returnPaxLabelShort !== undefined ? defaultData.returnPaxLabelShort : 'rtn'
      this.formData.paxQtyDiff = false // in and outbound quantities different.

      /* BINDINGS */
      this.outboundPeople = setupQuantityTicker(this.outboundPaxControl)
      this.returnPeople = setupQuantityTicker(this.returnPaxControl)

      this.setupPaxEvents()
    }

    /* EVENTS */
    this.setupEvents()
    if (isMobileDown() && this.showPax) {
      this.updatePaxQty()
    }

    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  setupPaxEvents () {
    this.allQtyBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.updatePaxQty()
      })
    })

    this.checkRelativePax.addEventListener('change', () => {
      this.toggleRelativePax()
      this.updatePaxQty()
    })

    this.modalPeopleClose.addEventListener('click', () => {
      this.closePeopleModal()
      this.buttonPeople.focus()
      allowBodyScroll()
    })

    this.buttonPeopleReset.addEventListener('click', () => {
      this.resetPeople()
      this.toggleRelativePax()
      this.updatePaxQty()
    })

    this.buttonPeople.addEventListener('click', () => {
      this.maximise()
      window.setTimeout(() => {
        this.toggleButtonState(this.buttonPeople)
        if (this.modalDate.hasAttribute('open')) {
          this.closeDateModal()
        }
        // this.toggleModal(this.modalPeople)
        this.openPeopleModal()
      }, 300)
    })

    this.buttonPeopleNext.addEventListener('click', () => {
      this.toggleButtonState(this.buttonPeople)
      if (this.modalPeople.hasAttribute('open')) {
        this.closePeopleModal()
        allowBodyScroll()
      }
    })
  }

  setupEvents () {
    this.buttonDirection.addEventListener('click', () => {
      this.maximise()
      this.swapDirection()
    })

    this.buttonDateReset.addEventListener('click', () => {
      this.resetDates()
    })

    this.modalDateClose.addEventListener('click', () => {
      this.closeDateModal()
      this.buttonDate.focus()
      allowBodyScroll()
    })

    this.buttonDate.addEventListener('click', () => {
      this.maximise()
      this.isReturn = false
      window.setTimeout(() => {
        this.toggleButtonState(this.buttonDate)
        if (this.showPax && this.modalPeople.hasAttribute('open')) {
          this.closePeopleModal()
          this.activeState = ''
        } else {
          this.activeState = 'date'
        }
        this.openDateModal()
        requestAnimationFrame(() => {
          this.setupDatePicker()
        })
      }, 300)
    })

    this.buttonReturnDate.addEventListener('click', () => {
      this.maximise()
      this.isReturn = true
      window.setTimeout(() => {
        this.toggleButtonState(this.buttonReturnDate)
        if (this.showPax && this.modalPeople.hasAttribute('open')) {
          this.closePeopleModal()
          this.activeState = ''
        } else {
          this.activeState = 'date'
        }
        this.openDateModal()
        requestAnimationFrame(() => {
          this.setupDatePicker(true)
        })
      }, 300)
    })

    // this.buttonDateNext.addEventListener('click', () => {
    //   this.setButtonInactive(this.buttonDate)
    //   if (this.showPax) {
    //     this.setButtonActive(this.buttonPeople)
    //     if (this.modalDate.hasAttribute('open')) {
    //       this.closeDateModal()
    //     }
    //     // this.toggleModal(this.modalPeople)
    //     this.openPeopleModal()
    //   } else {
    //     if (this.modalDate.hasAttribute('open')) {
    //       this.closeDateModal()
    //       // this.buttonSearch.focus()
    //       this.compileformData()
    //     }
    //   }
    // })

    this.buttonSearch.addEventListener('click', () => {
      this.compileformData()
    })

    // document.addEventListener('click', (e) => {
    //   this.handleClickOutside(e)
    // })

    document.addEventListener('keydown', (e) => {
      this.handleEscKey(e)
    })
  }

  toggleRelativePax () {
    if (this.showPax) {
      this.returnPaxControl.setAttribute('aria-hidden', !this.checkRelativePax.checked)
      this.formData.paxQtyDiff = this.checkRelativePax.checked
      if (this.checkRelativePax.checked) {
        this.outboundPaxLabel.textContent = this.labelStrings.outboundPaxLabelDiff
      } else {
        this.outboundPaxLabel.textContent = this.labelStrings.outboundPaxLabel
      }
    }
  }

  resetPeople () {
    if (this.showPax) {
      this.checkRelativePax.checked = false
      this.inputOutboundQty.value = 1
      this.inputReturnQty.value = 1
      this.outboundPeople.formdata.quantity = 1
      this.outboundPeople.setMinState()
      this.outboundPeople.setMaxState()
      this.returnPeople.formdata.quantity = 1
      this.returnPeople.setMinState()
      this.returnPeople.setMaxState()
    }
  }

  passengersSetOneWay () {
    if (this.showPax) {
      // Update underliying data.
      this.inputReturnQty.value = 0
      this.returnPeople.formdata.quantity = 0
      this.checkRelativePax.checked = false
      this.toggleRelativePax() // Hide return pax control.
      // Hide return pax control.
      this.relativePaxWrapper.setAttribute('aria-hidden', true)
      // Hide difference selector difference control.
    }
  }

  passengersSetReturn () {
    if (this.showPax) {
      this.inputReturnQty.value = 1
      this.returnPeople.formdata.quantity = 1

      // Hide return pax control.
      this.relativePaxWrapper.setAttribute('aria-hidden', false)
    }
  }

  getOffset () {
    if (getSize() === 'Tablet') {
      return 73 + 24
    } else {
      return 81 + 24
    }
  }

  updatePaxQty () {
    if (this.showPax) {
      if (this.formData.paxQtyDiff) {
        // set data...
        this.formData.outboundPax = this.inputOutboundQty.value
        this.formData.returnPax = this.inputReturnQty.value
        this.labelPeople.textContent = `${this.inputOutboundQty.value} ${this.labelStrings.outboundPaxLabelShort}, ${this.inputReturnQty.value} ${this.labelStrings.returnPaxLabelShort}`
      } else {
        this.formData.outboundPax = this.formData.returnPax = this.inputOutboundQty.value
        this.labelPeople.textContent = this.inputOutboundQty.value
      }
    }
  }

  arePaxValid () {
    if (this.showPax) {
      if ((this.formData.paxQtyDiff && this.formData.outboundPax > 0 && this.formData.returnPax > 0) ||
         (!this.formData.paxQtyDiff && this.formData.outboundPax > 0)) {
        return true
      }
    }

    return true
  }

  areDatesValid () {
    if ((this.formData.oneWay && this.formData.outboundDate !== '') ||
       (!this.formData.oneWay && this.formData.outboundDate !== '' && this.formData.returnDate !== '')) {
      return true
    }
    return false
  }

  setButtonActive (button) {
    button.setAttribute('aria-expanded', true)
  }

  setButtonInactive (button) {
    button.setAttribute('aria-expanded', false)
  }

  toggleButtonState (button = null) {
    if (this.buttonDate) {
      this.buttonDate.setAttribute('aria-expanded', false)
    }

    if (this.buttonReturnDate) {
      this.buttonReturnDate.setAttribute('aria-expanded', false)
    }

    if (this.buttonPeople) {
      this.buttonPeople.setAttribute('aria-expanded', false)
    }

    if (button) {
      button.setAttribute('aria-expanded', true)
    }
  }

  setupDatePicker (isReturn = false) {
    if (typeof (this.datePicker.destroy) === 'function' && this.datePicker.destroy !== undefined && this.datePicker.destroy !== null) {
      this.datePicker.destroy()
    }

    this.datePicker = setupDatePickersBookingBar(this.inputDates, isReturn, this.initialLoad)
    this.datePicker.config.onChange.push(() => {
      this.addSecondMonthLabel()
      this.setDates()
    })

    this.addSecondMonthLabel()
    this.datePicker.config.onMonthChange.push(() => {
      this.addSecondMonthLabel()
    })

    this.initialLoad = false
  }

  addSecondMonthLabel () {
    // Get ref to calendar control.
    const calRef = this.inputDates.nextElementSibling
    const nextMonth = new Date()
    nextMonth.setDate(1)
    nextMonth.setFullYear(this.datePicker.currentYear)
    nextMonth.setMonth(this.datePicker.currentMonth)
    nextMonth.setMonth(nextMonth.getMonth() + 1)

    const secondCalendar = calRef.querySelectorAll('.dayContainer')[1]
    const newContent = `<div class="flatpickr-second-month">${nextMonth.toLocaleDateString(this.lang, { month: 'long' })} ${nextMonth.getFullYear()}</div>`
    secondCalendar.insertAdjacentHTML('beforeend', newContent)
  }

  setDates () {
    // IF ONE WAY
    this.formData.outboundDate = this.formatFlatDate(this.datePicker.selectedDates[0])
    this.labelDate.textContent = this.formatDate(this.datePicker.selectedDates[0])

    // Repeat the same process for the return date if it exists
    if (this.datePicker.selectedDates[1]) {
      this.formData.returnDate = this.formatFlatDate(this.datePicker.selectedDates[1])
      this.labelReturnDate.textContent = this.formatDate(this.datePicker.selectedDates[1])
    } else {
      this.formData.returnDate = null
      this.labelReturnDate.textContent = this.labelStrings.itineraryLabel
    }

    if (!this.isReturn || this.datePicker.selectedDates[1]) {
      this.closeDateModal()
      this.buttonDate.focus()
      allowBodyScroll()
    }
  }

  formatFlatDate (date) {
    if (typeof (date) === 'undefined') {
      return
    }

    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day
  }

  resetDates () {
    this.datePicker.setDate(new Date())

    this.formData.outboundDate = new Date()
    this.formData.returnDate = ''

    this.labelDate.textContent = this.formatDate(this.formData.outboundDate)
    this.labelReturnDate.textContent = this.labelStrings.itineraryLabel
  }

  formatDate (dateInput) {
    if (typeof (dateInput) !== 'undefined') {
      const options = { day: 'numeric', month: 'short' }
      return dateInput.toLocaleDateString(this.lang, options)
    }
  }

  handleClickOutside (event) {
    const hasDialogAttached = event.target.getAttribute('data-dialog-open')
    if (this.elem.contains(event.target) || hasDialogAttached !== null) {
      return
    }
    if (this.isAnyModalOpen()) {
      this.closeDialogs()
      return
    }
    this.minimise()
  }

  handleEscKey (event) {
    if (event.key === 'Escape' && this.modalOpen === false) {
      this.minimise()
      this.closeDialogs()
    }
  }

  swapDirection () {
    const embark = this.formData.embark
    const disembark = this.formData.disembark

    this.formData.embark = disembark
    this.formData.disembark = embark

    this.labelDirectionFrom.textContent = this.formData.embark
    this.labelDirectionTo.textContent = this.formData.disembark
  }

  openDateModal () {
    this.modalDate.setAttribute('aria-hidden', false)
    this.modalDate.setAttribute('open', true)
    this.modalDate.classList.add('b-bar__modal--open')
    this.modalDateClose.focus()
    stopBodyScroll(this.bodyLockAttribute)
  }

  closeDateModal () {
    this.modalDate.setAttribute('aria-hidden', true)
    this.modalDate.classList.remove('b-bar__modal--open')
    this.modalDate.removeAttribute('open')
    this.toggleButtonState()
    this.buttonDate.focus()
  }

  closePeopleModal () {
    if (this.showPax) {
      this.modalPeople.setAttribute('aria-hidden', true)
      this.modalPeople.classList.remove('b-bar__modal--open')
      this.modalPeople.removeAttribute('open')
      this.toggleButtonState()
      this.buttonPeople.focus()
    }
  }

  openPeopleModal () {
    if (this.showPax) {
      this.modalPeople.setAttribute('aria-hidden', false)
      this.modalPeople.classList.add('b-bar__modal--open')
      this.modalPeople.setAttribute('open', true)
      this.modalPeopleClose.focus()
      stopBodyScroll(this.bodyLockAttribute)
    }
  }

  isAnyModalOpen () {
    if (this.modalDate.getAttribute('open') === 'true' || (this.showPax && this.modalPeople.getAttribute('open') === 'true')) {
      return true
    } else {
      return false
    }
  }

  maximise () {
    this.elem.classList.add(this.barMaxClass)
    if (this.hasPlaceHolder) {
      this.placeHolder.classList.add(this.phMaxClass)
    }
    if (this.showPax) {
      this.updatePaxQty()
    }
    document.addEventListener('click', this.handleClickOutside)
    // this.scrollToView()
  }

  scrollToView () {
    const offsetPosition = this.elem.offsetTop - this.getOffset()
    window.scrollTo({
      left: 0,
      top: offsetPosition,
      behavior: 'smooth'
    })
  }

  minimise () {
    document.removeEventListener('click', this.handleClickOutside)
    allowBodyScroll()
    if (this.showMax !== true) {
      this.elem.classList.remove(this.barMaxClass)
      if (this.hasPlaceHolder) {
        this.placeHolder.classList.remove(this.phMaxClass)
      }
    }
  }

  closeDialogs () {
    if (this.showPax) {
      this.buttonPeople.setAttribute('aria-expanded', false)
    }
    this.buttonDate.setAttribute('aria-expanded', false)
    this.closeDateModal()
    this.closePeopleModal()
    this.modalOpen = false
    document.removeEventListener('click', this.handleClickOutside)
    allowBodyScroll()
  }

  compileformData () {
    if (this.exportEvent === '') {
      this.logger.log(JSON.stringify(this.formData))
    } else {
      this.emitFormData()
    }
  }

  emitFormData () {
    this.logger.log('submit event')
    const event = new CustomEvent(this.exportEvent, {
      bubbles: true,
      detail: {
        formData: this.formData
      }
    })

    this.elem.dispatchEvent(event)
  }
}

export const setupBookingBar = function (parent) {
  const elems = parent.querySelectorAll('.b-bar')

  const bookingBars = []

  for (const elem of elems) {
    bookingBars.push(new BookingBar(elem))
  }
  return bookingBars
}
